import { Component, OnInit } from '@angular/core';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { QuotesService } from "../../_services/quotes.service";

import {first} from 'rxjs/operators';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'app-add-quote-content',
  templateUrl: './add-quote-content.component.html',
  styleUrls: ['./add-quote-content.component.css']
})
export class AddQuoteContentComponent implements OnInit {

  addQouteForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  uid: any;
  progress: number = 0;
  selectedfile: Array<File> = [];
  selectedfile1: Array<File> = [];
  mp4 = 'video/mp4';
  mp3 = 'audio/mp3';
  urls = new Array<string>();
  urls1 = new Array<string>();
  id = this.route.snapshot.params.id;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private quotesservice: QuotesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.uid = this.userdetaild['_id'];

    if (this.id !== undefined) {
        this.quoteById(this.id);
    }

    this.createAddQuoteForm();
    
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  createAddQuoteForm(){
    this.addQouteForm = this.formBuilder.group({
      type: ['', [Validators.required]],
      quote: [''],
      video: [''],
      audio: [''],
      text: [''],
    });
  }

  get f() { return this.addQouteForm.controls; }


  fileUpload(event) {
    this.urls = [];
    this.selectedfile = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile.length; i++) {
      if (this.selectedfile[i].type === this.mp4) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        };
        console.log(this.selectedfile[i]);
        console.log(this.urls);
        reader.readAsDataURL(this.selectedfile[i]);
      } else {
        this.addQouteForm.controls.video.reset();
        this.toaster.showError('File Type', 'Only MP4 video is allowed');
        return false;
      }
    }
  }

  fileUpload2(event) {
    this.urls = [];
    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      if (this.selectedfile1[i].type === this.mp3) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          // this.urlss.push(e.target.result);
          return true;
        };
        // console.log(this.selectedfile[i]);
        // console.log(this.urls);
        reader.readAsDataURL(this.selectedfile1[i]);
      } else {
        this.addQouteForm.controls.audio.reset();
        this.toaster.showError('File Type', 'Only MP3 is allowed');
        return false;
      }
    }
  }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addQouteForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      type: this.addQouteForm.controls.type.value,
      quote: (this.addQouteForm.controls.quote.value)?this.addQouteForm.controls.quote.value:'',
      text: (this.addQouteForm.controls.text.value)?this.addQouteForm.controls.text.value:'',
      video: (this.addQouteForm.controls.video.value)?this.addQouteForm.controls.video.value:'',
      audio: (this.addQouteForm.controls.audio.value)?this.addQouteForm.controls.audio.value:'',
      created_by: this.uid,
      updated_by: this.uid,
    };

    const formdata = new FormData();

    formdata.append('type', addPayload.type);
    formdata.append('quote', addPayload.quote);
    formdata.append('text', addPayload.text);
    formdata.append('video', addPayload.video);
    formdata.append('audio', addPayload.audio);
    formdata.append('created_by', addPayload.created_by);
    formdata.append('updated_by', addPayload.updated_by);
    // if (this.selectedfile) {
    //   const files: Array<File> = this.selectedfile;
    //   for (let i = 0; i < files.length; i++) {
    //     formdata.append('video', files[i], files[i].name);
    //   }
    // }

    // if (this.selectedfile1) {
    //   const files1: Array<File> = this.selectedfile1;
    //   for (let i = 0; i < files1.length; i++) {
    //     formdata.append('audio', files1[i], files1[i].name);
    //   }
    // }

    
      // if(this.selectedfile.length > 0 && this.selectedfile1.length > 0){
      //   // console.log('hhhhh', this.selectedfile);
      //   if (this.id !== undefined) {
      //     this.editQuoteWithProgress(this.id,formdata)
      //   } else {
      //     this.addQuoteWithProgress(formdata);
      //   }
      // } else {
      //   if (this.id !== undefined) {
      //     this.editQuote(this.id,formdata)
      //   } else {
      //     this.addQuote(formdata);
      //   }
      // }

      if (this.id !== undefined) {
        this.editQuote(this.id,addPayload)
      } else {
        this.addQuote(addPayload);
      }
      

  }

  addQuote(payload) {
    this.quotesservice.addQuoteContent(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Add Quote', data.ResponseMessage);
            this.router.navigate(['/get-quotes-content']);
          } else {
            this.toaster.showError('Add Quote', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add Quote', error);
        });
  }

  addQuoteWithProgress(payload) {
    this.quotesservice.addQuoteContentWithProgress(payload)
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              console.log('Request has been made!');
              break;
            case HttpEventType.ResponseHeader:
              console.log('Response header has been received!');
              break;
            case HttpEventType.UploadProgress:
              this.progress = Math.round(event.loaded / event.total * 100);
              console.log(`Uploaded! ${this.progress}%`);
              break;
            case HttpEventType.Response:
              console.log('File created!', event.body);
              setTimeout(() => {
                this.progress = 0;
                this.toaster.showSuccess('Add Content', event.body.ResponseMessage);
                this.router.navigate(['/get-quotes-content']);
              }, 1500);
  
            }
        },
        error => {
          this.toaster.showError('Add Quote', error);
        });
  }

  editQuoteWithProgress(id,payload) {
    this.quotesservice.editQuoteContentWithProgress(id,payload)
      .pipe(first())
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              console.log('Request has been made!');
              break;
            case HttpEventType.ResponseHeader:
              console.log('Response header has been received!');
              break;
            case HttpEventType.UploadProgress:
              this.progress = Math.round(event.loaded / event.total * 100);
              console.log(`Uploaded! ${this.progress}%`);
              break;
            case HttpEventType.Response:
              console.log('File created!', event.body);
              setTimeout(() => {
                this.progress = 0;
                this.toaster.showSuccess('Edit Content', event.body.ResponseMessage);
                this.router.navigate(['/get-quotes-content']);
              }, 1500);
  
            }
        },
        error => {
          this.toaster.showError('Add Quote', error);
        });
  }

  editQuote(id,payload) {
    this.quotesservice.editQuoteContent(id,payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Quote', data.ResponseMessage);
            this.router.navigate(['/get-quotes-content']);
          } else {
            this.toaster.showError('Add Quote', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add Quote', error);
        });
  }

  quoteById(id) {
    this.quotesservice.getQuoteContentById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
              let contentData = data.Data;
              this.addQouteForm.controls.type.setValue(contentData.type);
              this.addQouteForm.controls.quote.setValue(contentData.quote);
              this.addQouteForm.controls.text.setValue(contentData.text);
              this.addQouteForm.controls.video.setValue(contentData.video);
              this.addQouteForm.controls.audio.setValue(contentData.audio);
            }
            else{
              this.toaster.showError('Content', 'No data Found');
            }
        },
        error => {
          this.toaster.showError('Content', error);
        });
  }
}
